import { MessageCircleQuestion, Lightbulb } from "lucide-react";

/* "Ask the Community" / "Share a Tip" buttons placed INSIDE articles and guides.
   Scrolls to the discussion section and pre-selects the right post category. */
export default function AskCommunityCTA({ entityName, targetId = "forum" }) {
  const go = (tag) => {
    document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth", block: "start" });
    window.dispatchEvent(new CustomEvent("tp-open-composer", { detail: { tag } }));
  };
  return (
    <div className="border border-fuchsia-200 bg-fuchsia-50/60 p-4 flex flex-wrap items-center gap-3" data-testid="ask-community-cta">
      <div className="text-sm min-w-[200px] flex-1">
        <span className="font-700">Can't find what you're looking for?</span>{" "}
        Ask travelers{entityName ? <> about <b>{entityName}</b></> : null} — or share what you know.
      </div>
      <div className="flex gap-2">
        <button onClick={() => go("question")} data-testid="cta-ask-community"
          className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-700 text-white bg-fuchsia-600 hover:bg-fuchsia-700 transition-colors">
          <MessageCircleQuestion className="w-4 h-4" /> Ask the Community
        </button>
        <button onClick={() => go("travel_tip")} data-testid="cta-share-tip"
          className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-700 border border-fuchsia-400 text-fuchsia-700 hover:bg-fuchsia-100 transition-colors">
          <Lightbulb className="w-4 h-4" /> Share a Tip
        </button>
      </div>
    </div>
  );
}
